<template>
<v-card>
  <v-tabs v-model='activeTab' >
    <v-tab
      v-for='item in items' :key='item.title' >{{ item.title }}
    </v-tab>
    <v-spacer></v-spacer>
    <!-- {{spaceId}}: {{requests.get}} -->
    <v-tabs-items v-model='activeTab' class='px-2' >
      <v-tab-item v-for='item in items' :key='item.title' >
        <v-card>
          <request-status :request='requests.archive' />
          <v-card-text>
            <data-form v-model='settings' v-bind='item.attrs' >
              <template slot='actions-left' >
                <v-dialog width='500' >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color='error' text v-bind="attrs" v-on="on" >
                      Archive
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class='overline' >
                      Please confirm
                    </v-card-title>
                    <v-card-text>
                      Are you sure that you want to archive this space?
                    </v-card-text>
                    <v-card-actions >
                      <v-btn text >Cancel</v-btn>
                      <v-spacer />
                      <v-btn @click='archiveSpace(settings.service)'
                        :loading='requests.archive.loading'
                        color='error' >Archive</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
            </data-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</v-card>
</template>

<script>
// import Vue from 'vue'
import {RULES} from '@/store/constants'
import DataForm from '@/components/data/DataForm'
import BackgroundSelector from '@/components/ui/BackgroundSelector'
import HttpAutocomplete from '@/components/pickers/HttpAutocomplete'
import ColorPicker from '@/components/pickers/ColorPicker.vue'
import InvoiceDescriptionPicker from '@/components/pickers/InvoiceDescriptionPicker.vue'
import Vue from 'vue'

export default {
  name: 'SpaceSettings',
  components: { DataForm },
  props: {
    spaceId: { required: true },
    id: { required: true }
  },
  data () {
    return {
      activeTab: 0,
      space: {},
      settings: {},
      requests: {
        get: {
          resource: 'ag.spaces',
          result: {}
        },
        save: {
          resource: 'ag.spaces.settings',
          kwargs: {spaceId: this.spaceId},
          result: {}
        },
        archive: {
          resource: 'ag.spaces.practitioner',
          params: {action: 'archive'}
        }
      }
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) {
          Vue.set(this.settings, 'service', this.spaceId)
          this.get()
        }
      }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.space = this.getObjectPath(this.requests.get, 'result')
        this.settings = this.getObjectPath(this.requests.get, 'result.settings')
      }
    },
    archiveRequestStatus () {
      if (this.archiveRequestStatus === 204) {
        window.alert('Space has been archived')
        this.$router.push({path: '/settings/spaces'})
      }
    },
    backgroundPicture () {
      this.saveBackground()
    }
  },
  methods: {
    get () {
      if (this.spaceId) {
        this.requests.get.resourceId = this.spaceId
        this.$request('get', this.requests.get)
      }
    },
    archiveSpace (spaceId) {
      this.requests.archive.resourceId = spaceId
      this.$request('delete', this.requests.archive)
    },
    saveBackground () {
      this.requests.save.data = {background_picture: this.backgroundPicture}
      this.requests.save.resourceId = this.settings.id
      this.$request('save', this.requests.save)
    }
  },
  computed: {
    requestStatus () {
      return this.requests.get.status
    },
    archiveRequestStatus () {
      return this.requests.archive.status
    },
    backgroundPicture () {
      return this.getObjectPath(this.settings, 'background_picture')
    },
    items () {
      let settingsId = this.settings.id
      return [
        {
          title: 'About',
          attrs: {
            value: this.settings,
            request: this.requests.save,
            id: settingsId,
            fields: [
              {
                id: 'background_picture',
                component: BackgroundSelector,
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Choose a background image to go with this space',
                  hint: 'We will use this image when when visually displaying your space',
                  withUploader: true,
                  uploaderAttrs: {
                    uploadPath: `/api/v3/spaces/${this.spaceId}/settings/${settingsId}/`,
                    url: this.settings.logo_picture,
                    filename: 'logo_picture',
                    title: 'Upload a logo',
                    subtitle: 'Logo should be square or rectangle and will be used on your invoices and when displaying this space'
                  }
                }
              },
              // {
              //   id: 'title',
              //   containerAttrs: { xs12: true, sm12: true },
              //   attrs: { label: 'The name used to display this space' }
              // },
              {
                id: 'practice_name',
                containerAttrs: { xs12: true, sm6: true },
                attrs: { label: 'The official name of your practice or business' }
              },
              {
                id: 'practice_number',
                containerAttrs: { xs12: true, sm6: true },
                attrs: { label: 'Practice or registration number' }
              },
              {
                id: 'timezone',
                component: HttpAutocomplete,
                containerAttrs: { xs12: true, sm6: true },
                attrs: {
                  href: 'https://appointmentguru-co.appointmentguru.workers.dev/timezones',
                  attrs: {
                    label: 'Timezone',
                    clearable: true,
                    dense: true
                  }
                }
              },
              {
                id: 'currency',
                component: HttpAutocomplete,
                containerAttrs: { xs12: true, sm6: true },
                attrs: {
                  valueMapper: (item) => {
                    return {
                      value: item.value,
                      text: `${item.text} (${item.value})`
                    }
                  },
                  href: 'https://appointmentguru-co.appointmentguru.workers.dev/currencies',
                  attrs: {
                    label: 'Currency',
                    clearable: true,
                    dense: true,
                    rules: [RULES.required]
                  }
                }
              },
              {
                id: 'notification_instructions',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Custom text for notifications',
                  hint: 'You can use this to add a custom message specifically for this space to your notifications',
                  persistentHint: true,
                  outlined: true,
                  rows: 2,
                  class: 'caption'
                },
                component: 'vtextarea'
              },
              {
                id: 'general_settings',
                component: 'subheader',
                text: 'Settings',
                containerAttrs: { xs12: true },
              },
              // {
              //   id: 'private',
              //   attrs: {
              //     label: 'Private',
              //     persistentHint: true,
              //     color: 'warning',
              //     hint: 'Private spaces will not show up on your booking form',
              //     cardAttrs: {
              //       color: 'grey lighten-4'
              //     }
              //   },
              //   containerAttrs: { xs12: true },
              //   type: 'boolean',
              //   component: 'vcheckbox',
              //   extra: true
              // },
              {
                id: 'color',
                attrs: {
                  label: 'Color',
                  hint: 'The color used for highlighting this space when displaying on calendars etc.',
                  size: 20
                },
                containerAttrs: { xs12: true },
                component: ColorPicker,
              }
              // {
              //   id: 'dnager_zone',
              //   component: 'subheader',
              //   text: 'Danger Zone',
              //   containerAttrs: { xs12: true },
              // },
              // {
              //   id: 'archived',
              //   attrs: {
              //     label: 'Archived',
              //     persistentHint: true,
              //     color: 'error',
              //     hint: 'Archived spaces will not show up in the user inferface',
              //     cardAttrs: {
              //       color: 'grey lighten-4'
              //     }
              //   },
              //   containerAttrs: { xs12: true },
              //   type: 'boolean',
              //   component: 'vcheckbox',
              //   extra: true
              // },
            ]
          }
        },
        {
          title: 'Contact information',
          attrs: {
            value: this.settings,
            id: settingsId,
            request: this.requests.save,
            fields: [
              // {
              //   id: 'contact_email',
              //   containerAttrs: { xs12: true, sm6: true },
              //   attrs: { label: 'Primary contact email (for display purposes only)', type: 'email' }
              // },
              // {
              //   id: 'contact_phone_number',
              //   containerAttrs: { xs12: true, sm6: true },
              //   attrs: { label: 'Primary contact phone number (for display purposes only)', type: 'email' }
              // },
              {
                containerAttrs: { xs12: true },
                id: 'social_subheader',
                component: 'subheader',
                text: 'Social media'
              },
              {
                id: 'facebook',
                containerAttrs: { xs12: true, sm6: true },
                attrs: { label: 'facebook', type: 'url' }
              },
              {
                id: 'instagram',
                containerAttrs: { xs12: true, sm6: true },
                attrs: { label: 'instagram', type: 'url' }
              },
              {
                id: 'website',
                containerAttrs: { xs12: true, sm6: true },
                attrs: { label: 'website', type: 'url' }
              },
              {
                id: 'linkedin',
                containerAttrs: { xs12: true, sm6: true },
                attrs: { label: 'linkedin', type: 'url' }
              },
              {
                id: 'twitter',
                containerAttrs: { xs12: true, sm6: true },
                attrs: { label: 'twitter', type: 'url' }
              }
            ]
          }
        },
        {
          title: 'Invoice settings',
          previewURL: 'https://google.com',
          attrs: {
            value: this.settings,
            id: settingsId,
            request: this.requests.save,
            fields: [
              {
                id: 'billing_address',
                component: 'vtextarea',
                containerAttrs: { xs12: true, sm6: true, lg3: true },
                attrs: {
                  label: 'Billing address',
                  outline: true,
                  hint: 'This is the billing address that we will use on your invoices'
                }
              },
              {
                id: 'banking_details',
                component: 'vtextarea',
                containerAttrs: { xs12: true, sm6: true, lg3: true },
                attrs: {
                  label: 'Banking details',
                  outline: true,
                  hint: 'This is the billing address that we will show on your invoices'
                }
              },
              {
                id: 'invoice_notes',
                component: 'vtextarea',
                containerAttrs: { xs12: true, sm6: true, lg3: true },
                attrs: {
                  label: 'Invoice notes',
                  hint: 'A standard note to add to your invoices',
                  outline: true
                }
              },
              {
                id: 'receipt_notes',
                component: 'vtextarea',
                containerAttrs: { xs12: true, sm6: true, lg3: true },
                attrs: {
                  label: 'Receipt notes',
                  outline: true,
                  hint: 'A standard note to add to your receipts (e.g.: invoices that are paid)'
                }
              },
              // {
              //   id: 'background_color',
              //   attrs: {
              //     label: 'Invoice background color',
              //     hint: 'You can use a bold header with a background color'
              //   }
              // },
              // {
              //   id: 'text_color',
              //   attrs: {
              //     label: 'Invoice text color',
              //     hint: 'Use a color that will contrast well with the background color you have selected'
              //   }
              // },
              {
                id: 'preferences_title',
                component: 'subheader',
                text: 'Preferences'
              },
              {
                id: 'integrate_medical_aid',
                component: 'vcheckbox',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Include medical aid',
                  persistentHint: true,
                  hint: 'Include medical aid information on invoices'
                }
              },
              {
                id: 'include_booking_info',
                component: 'vcheckbox',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Include book online link',
                  persistentHint: true,
                  hint: 'Add a link to book an appointment online to your invoices'
                }
              },
              {
                id: 'auto_invoice_description',
                component: InvoiceDescriptionPicker,
                containerAttrs: { xs12: true },
                attrs: {}
              },
              {
                id: 'payments_title',
                component: 'subheader',
                text: 'Payments'
              },
              {
                id: 'payment_appointments_visible',
                component: 'vcheckbox',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Allow payments on appointment information page',
                  persistentHint: true,
                  hint: 'Show payment options on the appointment information page'
                }
              },
              {
                id: 'payment_appointments_prepayments',
                component: 'vcheckbox',
                onlyIfTrue: 'payment_appointments_visible',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Allow pre-payments',
                  persistentHint: true,
                  hint: 'Allow users to pay online before an appointment'
                }
              },
              {
                id: 'payment_appointments_only_if_invoiceable',
                component: 'vcheckbox',
                onlyIfTrue: 'payment_appointments_visible',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Only allow payments if I have marked the appointment as invoiceable',
                  persistentHint: true,
                  hint: 'This gives you total control over which appointments your users can pay for. Select this option if you would like to enable easy payments but may need to add some information to an appointment before a user can pay for it'
                }
              },
              {
                id: 'override_practitioner_settings',
                component: 'vcheckbox',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Override practitioner settings',
                  persistentHint: true,
                  hint: 'Prefer these settings over practitioner settings'
                }
              }
            ]
          }
        },
        {
          title: 'Content settings',
          attrs: {
            id: settingsId,
            value: this.settings,
            request: this.requests.save,
            fields: [
              {
                id: 'background_picture',
                component: BackgroundSelector,
                onlyIfTrue: 'is_website_published',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'The hero image for your website',
                  hint: 'Choose a dramatic picture to use in as the hero image on your website',
                  withUploader: false
                }
              },
              {
                id: 'slug',
                onlyIfTrue: 'is_website_published',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Choose a subdomain',
                  persistentHint: true,
                  suffix: '.appt.guru',
                  hint: 'We will publish your website to this url'
                }
              },
              {
                id: 'about_description',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'About us',
                  hint: 'A short paragraph or two describing the business - will be used on your Space website if you enable it',
                  persistentHint: true,
                  outlined: true,
                  rows: 2,
                  class: 'caption'
                },
                component: 'vtextarea'
              },
              {
                id: 'payments_title',
                component: 'subheader',
                text: 'Configuration'
              },
              // {
              //   id: 'is_website_published',
              //   component: 'vcheckbox',
              //   containerAttrs: { xs12: true },
              //   attrs: {
              //     label: 'Enable Website',
              //     persistentHint: true,
              //     hint: 'AppointmentGuru can generate a free website for you.'
              //   }
              // },
              {
                id: 'website_show_bookings',
                component: 'vcheckbox',
                // onlyIfTrue: 'is_website_published',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Allow online bookings',
                  persistentHint: true,
                  hint: 'Include the online booking form on your website'
                }
              },
              {
                id: 'website_whatsapp_click_to_chat_number',
                // onlyIfTrue: 'is_website_published',
                containerAttrs: { xs12: true },
                attrs: {
                  label: 'Whatsapp contact number',
                  persistentHint: true,
                  hint: 'Include a Whatsapp click to chat button on your website. Provide the WhatsApp number you would like to use'
                }
              }
            ]
          }
        }
      ]
    }
  }
}
</script>
